import React, { Component } from 'react';
import { imageProcessor } from 'utils';

let FilePicker = {};
class FilePickerProvider extends Component {
  state = {};

  TYPES = {
    IMAGE: 'Image',
    VIDEO: 'Videos',
    MEDIA: 'Media',
    DOCUMENT: 'Document',
    ALL: 'All'
  };

  TYPES_TO_EXT = {
    [this.TYPES.IMAGE]: 'image/*',
    [this.TYPES.VIDEO]: '.mp4',
    [this.TYPES.MEDIA]: 'image/* , .mp4',
    // [this.TYPES.DOCUMENT]: '.doc,.docx,.pdf, .xls,.xlsx'
    [this.TYPES.DOCUMENT]: 'application/*',
    [this.TYPES.ALL]: '*'
  };

  componentDidMount() {
    FilePicker = this;
  }

  show = (options, callback) => {
    this.setState({ ...options, callback }, () => this.ref.click());
  };

  onFilesAdded = async files => {
    const { asset_type, callback } = this.state;
    let assets = [];
    for (let file of files) {
      let asset = file;
      asset.url = URL.createObjectURL(file);
      if (file.type.includes('image')) {
        const img = await imageProcessor.fileToImg(file);
        asset.width = img.width;
        asset.height = img.height;
        asset.mediaType = 'photo';
      } else if (file.type.includes('video')) {
        const video = await this._processVideo(file);
        asset.width = video.width;
        asset.height = video.height;
        asset.duration = video.duration;
        asset.thumb = video.thumb;
        asset.mediaType = 'video';
      }
      asset.asset_type = asset_type;
      assets.push(asset);
    }
    callback && callback(assets);
  };

  _processVideo = file =>
    new Promise((resolve, reject) => {
      let video = document.createElement('video');
      let canvas = document.createElement('canvas');
      let thumb = new Image();
      let info = {};

      video.preload = 'auto';
      video.onloadeddata = () => {
        // window.URL.revokeObjectURL(video.src);
        info.duration = video.duration;
        canvas.width = info.width = video.videoWidth;
        canvas.height = info.height = video.videoHeight;

        canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        canvas.toBlob(blob => (thumb.src = URL.createObjectURL(blob)));
      };
      thumb.onload = () => resolve({ ...info, thumb });

      video.src = URL.createObjectURL(file);
    });

  render() {
    const { asset_type, multiple } = this.state;
    return (
      <input
        ref={ref => (this.ref = ref)}
        style={{ display: 'none' }}
        type="file"
        multiple={multiple}
        onChange={e => this.onFilesAdded(Object.values(e.target.files))}
        accept={this.TYPES_TO_EXT[asset_type] || this.TYPES_TO_EXT[this.TYPES.ALL]}
      />
    );
  }
}

export { FilePickerProvider, FilePicker };



// WEBPACK FOOTER //
// ./src/components/core/file_picker/index.web.js